import React, { useState, useEffect, useContext } from 'react';
import { Card, Progress, Button, Spin, Tooltip, notification, Drawer, Table, Tag, Input, Tabs, Space, Badge, DatePicker } from 'antd';
import ellipse from "assets/Ellipse.png";
import { monthEnum } from "components/common/enum";
import { EmployeeDetails } from "components/common/CommonComponent";
import { ImagePaths } from 'utils/ImagePath';
import click from "assets/FInger.png";
import useGetData from "components/common/useGetData";
import { getHomeDetails, getHappyMeter, getClockify } from './apihook';
import { formatTime12Hour, dateConvertor, extractFileExtension, formatTimeToAMPM } from 'components/common/validation';
import ToastMsg from 'components/common/ToastMsg'
import happyEmoji from "assets/happyEmoji.png";
import averageEmoji from "assets/averageEmoji.png";
import sadEmoji from "assets/sadEmoji.png";
import { useNavigate, useOutletContext } from 'react-router-dom'
import dayjs from 'dayjs';
import { AuthContext } from "context/auth/authentication";
import { quotes } from 'utils/quotes';
import moment from "moment-timezone";
import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, DownloadOutlined, FieldTimeOutlined, SearchOutlined, WarningOutlined } from '@ant-design/icons';
import useApiMethods from 'hooks/apiConfig/method/apiMethods';
import { CLOCKIFY, HAPPYMETER, HOME, EMPLOYEE_TRACKER ,NEW_EMPLOYEE_ATTENDANCE_CORRECTION_REQUEST, NEW_EMPLOYEE_ATTENDANCE_DAILY } from 'constant';
import axios from 'axios';
import { Modal } from 'antd';
import MyButton from 'components/ui/Button/MyButton';
import IconButton from 'components/ui/Button/IconButton';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
const { TabPane } = Tabs;

const Home = () => {
    const navigate = useNavigate();
    const employeeName = sessionStorage.getItem("employee_name")
    const authtoken = sessionStorage.getItem("token");
    const { logoutauth, loginauth, checkAuth, isAuthenticated } = useContext(AuthContext);
    // Current month and year:
    const currentDate = new Date();
    const currentMonthIndex = currentDate.getMonth();
    const currentMonthName = monthEnum[currentMonthIndex + 1];
    const currentYear = currentDate.getFullYear();

    // States of clock in , clock out and play paused:
    const [seconds, setSeconds] = useState(null);
    const [isClockIn, setIsClockIn] = useState(false);
    const [isPlayPause, setIsPlayPause] = useState(false);
    const [isClockOut, setIsClockOut] = useState(false);
    const [progressPercent, setProgressPercent] = useState(0);
    const { handleChildData } = useOutletContext();

    const [location, setLocation] = useState({
        latitude: null,
        longitude: null,
        city: null,
        street: null,
        address: null,
        timezone: null,
        currentTime: null,
        error: null,
        loading: false,
    });

    const { fetch, create, update } = useApiMethods();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState({status: '', attendanceId: ''});
    const [quote, setQuote] = useState(null);
    const [shiftTimeRemaining, setShiftTimeRemaining] = useState(null);
    const [daywish, setdaywish] = useState(null);

    // drawer states
    const [open, setOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [lateEmployees, setLateEmployees] = useState([]);
    const [lateEmployeesListLength, setLateEmployeesListLength] = useState(0)
    const [shortDutyEmployees, setShortDutyEmployees] = useState([]);
    const [shortDutyEmployeesListLength, setShortDutyEmployeesListLength] = useState(0)
    const [attendanceRequest, setAttendanceReqest] = useState([])
    const [newRequestAvail, setNewRequestAvail]=useState(false)
    const [actionModalVisible, setActionModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [actionType, setActionType] = useState("");
    const [editedCheckIn, setEditedCheckIn] = useState("");
    const [editedCheckOut, setEditedCheckOut] = useState("");
    const [adminComment, setAdminComment] = useState("");

    const is_super_admin = JSON.parse(sessionStorage.getItem("is_super_admin"));
    const is_admin = JSON.parse(sessionStorage.getItem("is_admin"));

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const [activeTab, setActiveTab] = useState("1");

    useEffect(() => {
        const savedTab = localStorage.getItem("attendanceTab");
        if (savedTab) setActiveTab(savedTab);
    }, []);

    const handleTabChange = (key) => {
        setActiveTab(key);
        localStorage.setItem("attendanceTab", key);
    };

    const fetchLateEmployees = async () => {
        try {
            let date = moment().format("YYYY-MM-DD")
            const query = `date=${date}&late_only=true&search=${searchText}`;
            const response = await fetch(NEW_EMPLOYEE_ATTENDANCE_DAILY, {query})
            const data = response.data || [];

            setLateEmployees(data);
            setLateEmployeesListLength(data.length);
        } catch (error) {
            console.error("Error fetching late employees:", error);
        }
    };

    const fetchShortDutyEmployees = async () => {
        try {
            let date = moment().subtract(1, "days").format("YYYY-MM-DD"); // previous day
            const query = `date=${date}&is_short_duty=true&search=${searchText}`;
            
            const response = await fetch(`${NEW_EMPLOYEE_ATTENDANCE_DAILY}?${query}`);
            const data = response.data || [];

            setShortDutyEmployees(data);
            setShortDutyEmployeesListLength(data.length || 0);
        } catch (error) {
            console.error("Error fetching late employees:", error);
        }
    };

    const fetchAttendanceRequestLogData = async () => {
        try {
            let response = await fetch(NEW_EMPLOYEE_ATTENDANCE_CORRECTION_REQUEST)
            const data = response.data || []

            setAttendanceReqest(data)

            const hasPending = data.some(item => item.status === "pending");
            setNewRequestAvail(hasPending);
        } catch (error) {
            console.error("Error fetching late employees:", error);
        }
    }

    useEffect(() => {
        if(is_admin && is_super_admin){
            fetchLateEmployees();
            fetchAttendanceRequestLogData()
            fetchShortDutyEmployees()
        }
    }, []);

    const handleDownload = () => {
        let header = "";
        let csvRows = [];

        if (activeTab === "1") {
            header = "Name,Department,Clock In Status\n";

            csvRows = lateEmployees.map(emp => {
            const employee = emp.employee_details || {};
            const name = `${employee.title || ""} ${employee.employee_name || ""}`.trim();
            const department = employee.department?.name || "N/A";
            const status = emp.check_in
                ? `Late at ${moment(emp.check_in).format("hh:mm A")}`
                : "Not Clocked In";

            return `${name},${department},${status}`;
            });

        } else if (activeTab === "2") {
            header = "Employee ID,Employee Name,Date,Check In,Check Out,Status,Reason,Requested On,Admin Comment\n";

            csvRows = attendanceRequest.map(req => {
            return [
                req.employee_id,
                req.employee_name,
                req.date,
                req.check_in,
                req.check_out,
                req.status,
                `"${req.reason}"`, // quote in case comma inside
                req.requested_on,
                `"${req.admin_comment || ""}"`
            ].join(",");
            });
        } else if (activeTab === "3") {
            header = "Name,Department\n";

            csvRows = shortDutyEmployees.map(emp => {
            const employee = emp.employee_details || {};
            const name = `${employee.title || ""} ${employee.employee_name || ""}`.trim();
            const department = employee.department?.name || "N/A";

            return `${name},${department}`;
            });
        }

        const blob = new Blob([header + csvRows.join("\n")], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = activeTab === '1'
            ? "late_attendance_summary.csv" :
            activeTab === '2'
            ? "attendance_correction_requests.csv" : 
            "short_duty_summary.csv";
        link.click();
        window.URL.revokeObjectURL(url);
    };

    const columns = [
        {
            title: "Employee Name",
            render: (_, record) => {
                let { employee_details } = record;
                let empDetails = {
                    ...record,
                    title: employee_details?.title ? employee_details?.title : "",
                    first_name: employee_details?.employee_name ? employee_details?.employee_name : "",
                    last_name: "",
                    designation_id: {
                        id: employee_details?.designation?.id ? employee_details?.designation?.id : "",
                        designation_name: employee_details?.designation?.name ? employee_details?.designation?.name : ""
                    },
                    id: employee_details.employee_id,
                    profile: employee_details.profile,
                }
                return (<EmployeeDetails details={empDetails} />)
            }
        },
        {
            title: "Clock-In Time",
            dataIndex: "clockInTime",
            key: "clockInTime",
            render: (time) => {
            if (!time) {
                return (
                <Tag color="red" icon={<WarningOutlined />} >
                    Not Clocked In
                </Tag>
                );
            }

            const clockInMoment = moment(time);
            const isLate = clockInMoment.isAfter(moment().startOf("day").hour(9).minute(15)); // cutoff 9:15 AM

            return (
                <div className="flex items-center gap-2">
                <span>{clockInMoment.format("hh:mm A")}</span>
                {isLate && (
                    <Tooltip title="Late Entry">
                    <Tag color="orange" icon={<ClockCircleOutlined />}>
                        Late
                    </Tag>
                    </Tooltip>
                )}
                </div>
            );
            },
        },
    ];

    const shortdutycolumns = [
        {
            title: "Employee Name",
            render: (_, record) => {
                let { employee_details } = record;
                let empDetails = {
                    ...record,
                    title: employee_details?.title ? employee_details?.title : "",
                    first_name: employee_details?.employee_name ? employee_details?.employee_name : "",
                    last_name: "",
                    designation_id: {
                        id: employee_details?.designation?.id ? employee_details?.designation?.id : "",
                        designation_name: employee_details?.designation?.name ? employee_details?.designation?.name : ""
                    },
                    id: employee_details.employee_id,
                    profile: employee_details.profile,
                }
                return (<EmployeeDetails details={empDetails} />)
            }
        }
    ];

    const handleAction = async (record, status, checkIn = null, checkOut = null, comment = "") => {
        if (!record?.id) return;

        try {
            const response = await update(NEW_EMPLOYEE_ATTENDANCE_CORRECTION_REQUEST, {
                id: record.id,
                status,
                check_in: checkIn,
                check_out: checkOut,
                admin_comment: comment || (status === 'approved' ? "Approved by admin" : "Rejected by admin"),
            });

            if (response?.status === "success") {
                ToastMsg("success", response.message);
                fetchAttendanceRequestLogData();
                setActionModalVisible(false);
            } else {
                ToastMsg("error", response.message || "Failed to update request");
            }
        } catch (err) {
            console.error("Action error:", err);
            ToastMsg("error", "Something went wrong");
        }
    };


    const requestColumns = [
        {
            title: "Employee Name",
            fixed: 'left',
            width: 150,
            render: (_, record) => {
                let { employee_details } = record;
                let empDetails = {
                    ...record,
                    title: employee_details?.title ? employee_details?.title : "",
                    first_name: employee_details?.employee_name ? employee_details?.employee_name : "",
                    last_name: "",
                    designation_id: {
                        id: employee_details?.designation?.id ? employee_details?.designation?.id : "",
                        designation_name: employee_details?.designation?.name ? employee_details?.designation?.name : ""
                    },
                    id: employee_details?.employee_id,
                    profile: employee_details?.profile,
                }
                return (<EmployeeDetails details={empDetails} />)
            }
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            width: 100,
        },
        {
            title: 'Check-In',
            dataIndex: 'check_in',
            key: 'check_in',
            width: 100,
        },
        {
            title: 'Check-Out',
            dataIndex: 'check_out',
            key: 'check_out',
            width: 100,
        },
        {
            title: 'Reason',
            dataIndex: 'reason',
            key: 'reason',
            width: 240,
            render: (text) => <span className="text-gray-600 text-sm">{text}</span>,
        },
        {
            title: 'Requested On',
            dataIndex: 'requested_on',
            key: 'requested_on',
            width: 160,
            render: (text) => <span className="text-xs text-gray-500">{text}</span>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 120,
            render: (status) => {
            const color = status === 'approved' ? 'green' : status === 'rejected' ? 'red' : 'orange';
            return <Tag color={color}>{status.toUpperCase()}</Tag>;
            },
        },
        {
            title: 'Actions',
            key: 'actions',
            fixed: 'right',
            width: 130,
            render: (_, record) => {
                if (record.status === 'approved' || record.status === 'rejected') {
                    return <span className="text-gray-400 text-xs">Already {record.status}</span>;
                }
                
                return (
                    <Space>
                        <Tooltip title="Approve Request">
                            <IconButton
                                size="small"
                                icon={<CheckCircleOutlined />}
                                onClick={() => {
                                    setSelectedRecord(record);
                                    setActionType('approved');

                                    const date = record.date; // "2025-07-07"
                                    const checkInString = `${date} ${record.check_in}`; // e.g., "2025-07-07 06:00 AM"
                                    const checkOutString = `${date} ${record.check_out}`; // e.g., "2025-07-07 09:30 PM"

                                    // Convert to dayjs with 12-hour format
                                    const parsedCheckIn = dayjs(checkInString, 'YYYY-MM-DD hh:mm A');
                                    const parsedCheckOut = dayjs(checkOutString, 'YYYY-MM-DD hh:mm A');

                                    console.log(parsedCheckIn); // "2025-07-07T00:30:00.000Z"
                                    console.log(parsedCheckOut); // "2025-07-07T16:00:00.000Z"
                                    

                                    setEditedCheckIn(parsedCheckIn.isValid() ? parsedCheckIn : null);
                                    setEditedCheckOut(parsedCheckOut.isValid() ? parsedCheckOut : null);

                                    setAdminComment("Approved by admin");
                                    setActionModalVisible(true);
                                }}
                            />
                        </Tooltip>
                        <Tooltip title="Reject Request">
                            <IconButton
                                size="small"
                                icon={<CloseCircleOutlined className='text-red-400' />}
                                onClick={() => handleAction(record, 'rejected')}
                            />
                        </Tooltip>
                    </Space>
                );
            }
        },
    ];

    const renderDateTimeField = (label, value, onChange) => (
        <div>
            <label className="block text-xs font-medium text-black/80 mb-1">{label}</label>
            <DatePicker
                showTime={{ use12Hours: true }}
                format="YYYY-MM-DD hh:mm A"
                className="w-full"
                placeholder="Select"
                value={dayjs.isDayjs(value) ? value : null}
                onChange={onChange} 
            />
        </div>
    );


    const renderCommentField = () => (
        <div>
            <label className="block text-xs font-medium text-black/80 mb-1">Admin Comment</label>
            <textarea
                rows={3}
                placeholder="Enter reason or notes"
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm"
                value={adminComment}
                onChange={(e) => setAdminComment(e.target.value)}
            />
        </div>
    );


    const fetchHomeDetails = async() =>{
        setLoading(true);
        try {
            const res = await fetch(HOME)
            if (res){
                if (res.status === 'success'){
                    const resData = res.data;
                    setData(resData)   
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }
    const is_password_updated = JSON.parse(sessionStorage.getItem("is_password_updated"));
    let { notice_board, upcoming_events, my_leaves, password_policy, payroll_custom_configuration, salary_calculation} = data || {};
    let dataList = (password_policy && password_policy?.length > 0) ? { ...password_policy[0] } : {};
    let customData = (payroll_custom_configuration && payroll_custom_configuration?.length > 0) ? { ...payroll_custom_configuration[0] } : {};
    sessionStorage.setItem("passwordPolicy", JSON.stringify(dataList));
    sessionStorage.setItem("customConfig", JSON.stringify(customData));
    sessionStorage.setItem("salary_calculation", salary_calculation);

    const getAddress = async (latitude, longitude) => {
        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`
            );
            const data = await response.json();
            const { city, road } = data.address;
            setLocation((prevState) => ({
                ...prevState,
                city,
                street: road,
            }));
        } catch (error) {
            ToastMsg("error", error);
        }
    };
    
    useEffect(() => {
        if (!authtoken) {
            window.location.href = "/";
        } else{
            fetchHomeDetails();
        }
    }, [authtoken, filter]);

    useEffect(() => {
        if(!is_password_updated && dataList?.id){
          navigate("/employeeprofile", { state: { fromEdit: true} });
        }
    },[dataList?.id, is_password_updated])
    
    useEffect(() => {
        getLocation();
    }, []);

    // useEffect(() => {
    //     if (_message && _message.isErrorMsg && _message.errorMsgText) {
    //       ToastMsg('error', _message.errorMsgText);
    //     }
    //   }, [_message.errorMsgText]);

    useEffect(() => {
        const currentDate = dayjs();
        let intervalId = null;
    
        if (data) {
          const givenDate = dayjs(data.date);
    
          if (givenDate.isSame(currentDate, 'day') && !data.check_in && !data.check_out) {
            setIsClockOut(false);
          } else if (data.check_out) {
            setIsClockOut(true);
            setIsClockIn(false);
            setIsPlayPause(false);
            setSeconds(null);
            setShiftTimeRemaining(null);
          } else if (data.working_hrs && data.clock_status === 'pause') {
            setSeconds(parseFloat(data.working_hrs));
            setIsPlayPause(true);
            setIsClockIn(true);
          } else if (data.clock_status === 'resume' && data.resume) {
            setIsPlayPause(false);
            setIsClockIn(true);
            const calculateResumetime = () => {
              const resumeInTime = new Date(data.resume).getTime();
              const currentTime = Date.now();
              const resumTimeInSeconds = Math.floor((currentTime - resumeInTime) / 1000);
              return parseFloat(data.working_hrs) + resumTimeInSeconds;
            };
            setSeconds(calculateResumetime());
            intervalId = setInterval(() => {
              setSeconds(calculateResumetime());
            }, 1000);
          } else if (data.check_in) {
            setIsClockIn(true);
            const calculateCheckInTime = () => {
              const checkInDate = new Date(data.check_in).getTime();
              const currentTime = Date.now();
              const workingHoursInSeconds = Math.floor((currentTime - checkInDate) / 1000);
              return Math.max(workingHoursInSeconds, 0);
            };
            setSeconds(calculateCheckInTime());
            intervalId = setInterval(() => {
              setSeconds(calculateCheckInTime());
            }, 1000);
          }
    
          handleChildData({ ...data });
        }
        return () => {
          if (intervalId) clearInterval(intervalId);
        };
      }, [data]);

    useEffect(() => {
    var today = new Date()
    var curHr = today.getHours()
    if (curHr < 12) {
        setdaywish("Morning");
    } else if (curHr < 18) {
        setdaywish("Afternoon");
    } else {
        setdaywish("Evening");
    }
    }, [])
    const getLocation = () => {
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const { latitude, longitude } = position.coords;
                const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;

                try {
                    const response = await axios.get(url);
                    
                    // const data = await response.json();

                    const { address } = response?.data;

                    setLocation(() => ({
                        latitude: latitude,
                        longitude: longitude,
                        city: address?.city || address?.town || address?.village,
                        street: address?.suburb,
                        address: address,
                    }))
                } catch (error) {
                    console.error("Error fetching location details:", error);
                }
            },
            (error) => {
                console.error(`Error: ${error.message}`);
            },
            {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0,
            }
        );
    };

    // CountDown timer 
    // useEffect(() => {
    //     let interval;
    //     if (isClockIn && !isPlayPause && data?.check_in) {
    //         interval = setInterval(() => {
    //             setSeconds(prevState => prevState + 1);
    //         }, 1000);
    //     } else {
    //         clearInterval(interval);
    //         if (!data?.check_in) {
    //             setSeconds(null);
    //         }
    //     }

    //     return () => clearInterval(interval);
    // }, [isClockIn, isPlayPause, data?.check_in]);


    useEffect(() => {
      // Check if a quote index is already stored in sessionStorage
      const storedQuoteIndex = sessionStorage.getItem('quoteIndex');
      let index;
  
      if (storedQuoteIndex) {
        index = storedQuoteIndex; // Use the stored index
      } else {
        // Randomly choose an index if it's not stored
        index = Math.floor(Math.random() * quotes.length);
        sessionStorage.setItem('quoteIndex', index); // Store it for the day
      }
  
      setQuote(quotes[index]); // Set the selected quote
    }, []);

    // useEffect(() => {
    //     // Fetch data when the component mounts
    //     fetch('/api/today')
    //         .then((response) => {
    //             console.log(response);
    //             if (!response.ok) {
    //             throw new Error('Failed to fetch quote');
    //             }
    //             return response.json();
    //         })
    //         .then((data) => {
    //             setQuote(data[0]); // Assuming you want the first quote in the response
    //         })
    //         .catch((err) => {
                
    //         });
    // }, []);

    useEffect(() => {
        if (Notification.permission === "default" || Notification.permission === "denied") {
            Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                    alert("Notification permission granted!");
                } else {
                    alert("Notification permission denied.");
                }
            });
        }
    }, [isClockIn])


    useEffect(() => {
        if (!data?.shift_start_time || !data?.shift_end_time) {
            console.error('Shift start or end time is missing.');
            return;
        }

        const startTime = new Date(data.shift_start_time);
        const endTime = new Date(data.shift_end_time);

        if (endTime < startTime) {
            endTime.setDate(endTime.getDate() + 1);
        }

        const shiftDuration = endTime.getTime() - startTime.getTime();

        const calculateTimeLeft = () => {
            const now = new Date();
            const timeDiff = endTime.getTime() - now.getTime();
            return Math.max(timeDiff, 0);
        };

        const timer = setInterval(() => {
            const remainingTime = calculateTimeLeft();
            setShiftTimeRemaining(remainingTime);
            setSeconds(parseFloat(data.working_hrs)); // temp solution
            const elapsedDuration = shiftDuration - remainingTime;
            const progressPercent = (elapsedDuration / shiftDuration) * 100;
            setProgressPercent(progressPercent);

            if (remainingTime === 0) {
                clearInterval(timer);
            }
        }, 1000);
        return () => clearInterval(timer);
    }, [data?.shift_start_time, data?.shift_end_time]);

    const formatshiftTime = (milliseconds) => {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const formatTime = (timeInSeconds) => {
        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds % 3600) / 60);
        const seconds = timeInSeconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const handleClockify = async (clockifyStatus) => {
        if (clockifyStatus) {
            console.log(clockifyStatus,"clockifyStatus");
            
            const updatedFilter = {
                ...filter,
                status: clockifyStatus,
                attendanceId: data.attendance_id,
            };
    
            setFilter(updatedFilter);
            
            try {
                if (loading) return; // prevents double call
                setLoading(true)
                const res = await fetch(CLOCKIFY, updatedFilter)
                const result = await res;
                
                if (result && result.detail === "You are not authorized to perform this action") {
                    logoutauth();
                    navigate("/", { replace: true });
                  }
                  if (result.status === 'success') {
                    ToastMsg('success', result.message);
                    if (clockifyStatus === 'clock_out') {
                      setIsClockOut(true);
                      setIsClockIn(false);
                      setIsPlayPause(false);
                      setSeconds(null);
                      setShiftTimeRemaining(null);
                    } else if (clockifyStatus === 'pause') {
                      setIsPlayPause(true);
                    } else if (clockifyStatus === 'resume') {
                      setIsPlayPause(false);
                    } else if (clockifyStatus === 'clock_in') {
                      setSeconds(0);
                      setIsClockIn(true);
                      setIsClockOut(false); // just in case
                    }
            
                    await fetchHomeDetails(); // Refresh after API success
                  } else {
                    ToastMsg('error', result.message || 'Unexpected response');
                  }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false)
            }
        }
    }

    const handleGeoLocation = (type) => {        
        try {
            let data = {
                "latitude" : JSON.stringify(location?.latitude),
                "longitude" : JSON.stringify(location?.longitude),
                "location" : location?.address?.suburb,
                "city": location?.address?.state_district,
                "location_type" : type
            }
            create(EMPLOYEE_TRACKER, data)
            if (data.status === "success") {
                console.log("success", data?.message)
            }
            else if (data.status === "fail") {
                ToastMsg("error", data.message);
            }
        } catch (error) {
            ToastMsg("error", error.message);
        }
    };

    const handleClick = () => {
        handleClockify("clock_in");
    }

    const handlePlayPause = () => {
        if (loading) return;
        const nextStatus = !isPlayPause;
        handleClockify(nextStatus ? "pause" : "resume");
        setIsPlayPause(nextStatus);
    };

    const handleClockOutClick = () => {
        const currentTime = dayjs().format('hh:mm A'); // Format: 12-hour with AM/PM

        Modal.confirm({
            title: 'Confirm Clock Out',
            content: `Are you sure you want to clock out at ${currentTime}?`,
            okText: 'Yes, Clock Out',
            cancelText: 'Cancel',
            okButtonProps: {
              style: {
                backgroundColor: '#d9363e',
                borderColor: '#d9363e',
                color: 'white',
                borderRadius: '4px',
                padding: '6px 16px',
                fontWeight: '500',
              },
            },
            cancelButtonProps: {
              style: {
                backgroundColor: '#f0f0f0',
                borderColor: '#d9d9d9',
                color: '#333',
                borderRadius: '4px',
                padding: '6px 16px',
                fontWeight: '500',
              },
            },
            onOk() {
              handleClockify('clock_out');
            },
          });
          
    }

    console.log("Clicked play/pause, current isPlayPause:", isPlayPause);

    const handleHappyMeterClk = async (status) => {    
        if (status) {
            setFilter((prev) => {
                return { ...prev, status: status };
            });
    
            try {
                setLoading(true);
                const res = await fetch(HAPPYMETER, filter);    
                if (res) {
                    if (res.status === 'success') {
                        // Customize message based on the status
                        let message = "";
                        switch (status) {
                            case "sad":
                                message = "We're sorry to hear that. Your feedback has been sent to your reporting manager.";
                                break;
                            case "average":
                                message = "Thanks for your input. Your reporting manager has been notified.";
                                break;
                            case "happy":
                                message = "Great to know! Your positive feedback has been shared with your reporting manager.";
                                break;
                            default:
                                message = "Your feedback has been sent.";
                                break;
                        }
    
                        ToastMsg("success", message);
                    }
                }
            } catch (error) {
                console.log(error);
                ToastMsg("error", "Something went wrong. Please try again later.");
            } finally {
                setLoading(false);
            }
        }
    };    

    const [zoneLocation, setZoneLocation] = useState({
        timezone: null,
        currentTime: null,
        error: null,
        loading: false,
      });
    
      const apiKey = "AIzaSyB0ELCjrI1Sw8YQyIszUtGBaEe-wOEkeY8"; // Replace with your API Key
    
      const getLocationForZone = () => {
        setZoneLocation((prev) => ({ ...prev, loading: true }));
    
        if (!navigator.geolocation) {
            setZoneLocation({
            error: "Geolocation is not supported by your browser",
            loading: false,
            });
            return;
        }

        navigator.geolocation.getCurrentPosition(
            async (position) => {
            const { latitude, longitude } = position.coords;
            await getTimeZone(latitude, longitude);
          },
          (error) => {
            setZoneLocation({
              error: "Unable to retrieve location",
              loading: false,
            });
            }
        );
    };

    const getTimeZone = async (lat, lng) => {
        try {
            const timestamp = Math.floor(Date.now() / 1000);
            const url = `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${apiKey}`;
            const response = await axios.get(url);
            const data = await response.json();
            
            if (data.status === "OK") {
                setLocation({
                    timezone: data.timeZoneName,
                    currentTime: moment().tz(data.timeZoneId).format("LLLL"),
                    loading: false,
                    error: null,
                });
            }
        } catch (error) {
            setLocation({
            timezone: "Time Zone Not Found",
            loading: false,
            error: "Error fetching time zone",
            });
        }
      };
    
      useEffect(() => {
        getLocationForZone()
        const interval = setInterval(() => {
          if (zoneLocation.timezone) {
            setZoneLocation((prev) => ({
              ...prev,
              currentTime: moment().tz(prev.timezone).format("LLLL"),
            }));
            }
        }, 1000);
        return () => clearInterval(interval);
      }, [zoneLocation.timezone]);

    return (
        <>
            {/* daily quotes and current time */}
            { quote && 
                <div className=' px-1 flex justify-between items-center mb-1'>
                    <div>
                        <span className='common_addTltTxt' style ={{marginRight:"auto"}}>Good {daywish} , {employeeName}!</span>
                        <div className=' w-[40dvw] flex text-xs'>
                            <span>{quote.q}</span>
                            <i className='text-end mt-3'>- {quote.a}</i> 
                        </div>
                    </div>
                    <>
                        {
                            (is_super_admin && is_admin) &&
                            (
                                <div className=' flex gap-2 justify-center items-center bg-white p-2 rounded-lg'>
                                    {/* <p>Time Zone: {zoneLocation.timezone}</p> */}
                                    {/* {zoneLocation.timezone && (
                                    <div className=' flex flex-col'>
                                        <p className=' text-end text-[0.70rem] font-light'>Current Time</p>
                                        <p className=' text-[0.75rem] font-semibold'>{zoneLocation.currentTime}</p>
                                    </div>
                                    )} */}
                                    <FieldTimeOutlined className=' w-5 h-5 text-lg' />
                                    <div className="flex items-center gap-2">
                                        <div className="relative">
                                            <MyButton type="primary" label="Timesheet Management" onClick={showDrawer} />
                                            {newRequestAvail && (
                                                <span className="absolute top-0 right-0 translate-x-1/2 -translate-y-1/2">
                                                    <Badge dot className=' animate-pulse' />
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <Drawer
                                        title={
                                            <div className="flex justify-between items-center w-full h-4 text-sm">
                                                <span className="font-semibold">Timesheet Management</span>
                                                <Tooltip title="Download CSV">
                                                    <div
                                                        onClick={handleDownload}
                                                        className="p-2 rounded-md text-gray-600 hover:text-blue-600 hover:bg-blue-50 transition cursor-pointer text-center flex justify-center items-center gap-2"
                                                    >
                                                        <DownloadOutlined style={{ fontSize: 18 }} />
                                                        {" "} 
                                                        {activeTab === '1' ? 
                                                            <span className='flex justify-center items-center gsp-1'>
                                                                Late Arrivals Summary - <Badge count={lateEmployeesListLength} style={{ backgroundColor: '#ff0000c7', marginLeft: 4, marginTop: 3 }} />
                                                            </span> : activeTab === '3' ? 
                                                            <span>    
                                                                Short Duty Summary - <Badge count={shortDutyEmployeesListLength || 0} style={{ backgroundColor: '#ff0000c7', marginLeft: 4, marginTop: 3 }} />
                                                            </span>
                                                        : 'Requests'}
                                                    </div>
                                                </Tooltip>
                                            </div>
                                        }
                                        placement="right"
                                        onClose={onClose}
                                        open={open}
                                        width={700}
                                    >
                                        <Tabs activeKey={activeTab} onChange={handleTabChange} className="px-2 py-0">
                                            {/* Tab 1: Late Summary */}
                                            <TabPane tab="Late Summary" key="1">
                                                <div className="py-2 border-b">
                                                    <Input
                                                        allowClear
                                                        size="middle"
                                                        placeholder="Search by name or department"
                                                        prefix={<SearchOutlined className="text-gray-500 m-1" />}
                                                        value={searchText}
                                                        onChange={(e) => setSearchText(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                fetchLateEmployees(); // your API call
                                                            }
                                                        }}
                                                        className="rounded-md h-9 flex items-center"
                                                        style={{ borderRadius: 6 }}
                                                    />
                                                </div>

                                                <div style={{ maxHeight: "calc(100vh - 230px)", overflowY: "auto", padding: "16px" }}>
                                                    <Table
                                                        columns={columns}
                                                        dataSource={lateEmployees}
                                                        rowKey="id"
                                                        pagination={false}
                                                        rowClassName={(record) => !record.clockInTime ? 'bg-red-50' : ''}
                                                        locale={{ emptyText: "All employees clocked in on time." }}
                                                    />
                                                </div>
                                            </TabPane>

                                            {/* Tab 2: Correction Requests */}
                                            <TabPane tab={<span>
                                                Attendance Requests
                                                {newRequestAvail && <Badge dot className="ml-2" />}
                                            </span>} key="2">
                                                <div className="py-2 text-gray-600 text-sm">
                                                    <Table
                                                        columns={requestColumns}
                                                        dataSource={attendanceRequest}
                                                        rowKey="id"
                                                        pagination={false}
                                                        locale={{ emptyText: "No request available." }}
                                                        scroll={{ x: 'max-content' }}
                                                        bordered
                                                    />

                                                    <Modal
                                                        title="Confirm Approval"
                                                        visible={actionModalVisible}
                                                        onCancel={() => setActionModalVisible(false)}
                                                        footer={[
                                                            <MyButton
                                                                key="cancel"
                                                                label="Cancel"
                                                                onClick={() => setActionModalVisible(false)}
                                                                outlined
                                                                type="default"
                                                            />,
                                                            <MyButton
                                                                key="submit"
                                                                label="Approve Request"
                                                                onClick={() =>
                                                                    handleAction(
                                                                        selectedRecord,
                                                                        "approved",
                                                                        editedCheckIn?.format("HH:mm:ss"),
                                                                        editedCheckOut?.format("HH:mm:ss"),
                                                                        adminComment
                                                                    )
                                                                }
                                                            />,
                                                        ]}
                                                    >
                                                        <div className="flex flex-col gap-4">
                                                            {renderDateTimeField("Check-In Date & Time", editedCheckIn, setEditedCheckIn)}
                                                            {renderDateTimeField("Check-Out Date & Time", editedCheckOut, setEditedCheckOut)}
                                                            {renderCommentField()}
                                                        </div>
                                                    </Modal>
                                                </div>
                                            </TabPane>

                                            {/* Tab 3: Short duty attendance */}
                                            <TabPane tab="Short Duty Summary" key="3">
                                                <div className="py-2 border-b">
                                                    <Input
                                                        allowClear
                                                        size="middle"
                                                        placeholder="Search by name or department"
                                                        prefix={<SearchOutlined className="text-gray-500 m-1" />}
                                                        value={searchText}
                                                        onChange={(e) => setSearchText(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                fetchShortDutyEmployees(); // your API call
                                                            }
                                                        }}
                                                        className="rounded-md h-9 flex items-center"
                                                        style={{ borderRadius: 6 }}
                                                    />
                                                </div>

                                                <div style={{ maxHeight: "calc(100vh - 230px)", overflowY: "auto", padding: "16px" }}>
                                                    <Table
                                                        columns={shortdutycolumns}
                                                        dataSource={shortDutyEmployees}
                                                        rowKey="id"
                                                        pagination={false}
                                                        locale={{ emptyText: "No Short dutys recorded for yesterday attendance" }}
                                                    />
                                                </div>
                                            </TabPane>
                                        </Tabs>
                                    </Drawer>
                                </div>
                            )
                        }
                    </>
                </div>
            }

            <div class="parent">
                {loading && (
                        <div className="loaderOverlay">
                            <Spin />
                        </div>
                    )}
                <div class="div1">
                    <Card className="h-full bg-gradient-to-r from-white via-gray-100 to-white rounded-lg">
                        <p id="common_salary_subTxt" className='pb-2 border-b'>Attendance</p>
                        <div className=" flex items-center justify-center mt-1">
                            {(isClockIn || isPlayPause) ? (
                                <div className="flex flex-col md:flex-row items-center justify-between w-full gap-4">
                                    {/* Left Side - Timer & Shift Ends In */}
                                    <div className="flex flex-col gap-5 items-start">
                                        <div>
                                            {shiftTimeRemaining === 0 ? (
                                                <div className="text-left border-l-2 border-cyan-600 pl-2">
                                                    <p className="text-gray-600 text-[0.75vw] font-medium tracking-wide uppercase mb-[2px]">Total Work Hrs</p>
                                                    <div className="text-[1.15vw] font-semibold flex items-center gap-2">{formatTime(seconds)}</div>
                                                    <p className="text-[10px] text-gray-600 mt-1">You're doing great! Keep it up. 🚀</p>
                                                </div>
                                            ) : shiftTimeRemaining !== null ? (
                                                <div className="border-l-2 border-[#10BBB5] text-left pl-2">
                                                    <div className='flex items-center justify-between gap-5 w-44'>
                                                        <div className="flex flex-col w-1/2">
                                                            <p className="text-gray-600 text-[0.75vw] font-medium tracking-wide uppercase mb-[2px]">Time Left</p>
                                                            <span className="text-[1.15vw] font-semibold text-gray-800">
                                                                {formatshiftTime(shiftTimeRemaining)}
                                                            </span>
                                                        </div>
                                                        {
                                                            isPlayPause ?
                                                            <div className="flex flex-col w-1/2">
                                                                <p className="text-gray-600 text-[0.75vw] font-medium tracking-wide uppercase mb-[2px]">Total Work</p>
                                                                <span className="inline-flex items-center gap-2 px-3 py-[4px] bg-[#10BBB5] text-white text-[0.75vw] rounded-full shadow">
                                                                    <svg
                                                                        className="w-[0.85vw] h-[0.85vw] animate-spin-slow"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        strokeWidth="2"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path d="M12 6v6l4 2" />
                                                                        <circle cx="12" cy="12" r="10" />
                                                                    </svg>
                                                                    {formatTime(seconds)}
                                                                </span>
                                                            </div> : null
                                                        }
                                                    </div>
                                                    <p className="text-[10px] text-gray-600 mt-1"> <span className="animate-pulse text-[#10BBB5] text-sm">⏳</span>You're almost there, stay focused!</p>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>

                                    {/* Right Side - Progress Bar, Play/Pause, Clock Out */}
                                    <div className="flex flex-col items-center justify-center relative w-full md:w-auto">
                                        <Progress
                                            type="circle"
                                            percent={progressPercent}
                                            width={'8vw'}
                                            showInfo={false}
                                            strokeWidth={5}
                                            strokeColor={{
                                                "0%": "#04B7B1",
                                                "10%": "#04B5AF",
                                                "20%": "#04B4AE",
                                                "30%": "#04B2AC",
                                                "40%": "#10BBB5",
                                                "50%": "#1BC3BE",
                                                "60%": "#1BC8C2",
                                                "70%": "#16C3BD",
                                                "80%": "#11BDB8",
                                                "90%": "#0CB8B3",
                                                "100%": "#00736F",
                                            }}
                                        />

                                        <div className="absolute flex justify-center items-center flex-col z-10">
                                            {/* Play/Pause Button */}
                                            <img
                                                src={isPlayPause ? ImagePaths.playIcon.default : ImagePaths.pauseIcon.default}
                                                alt="playPause"
                                                className={`playPauseIcon cursor-pointer ${loading ? 'opacity-50 pointer-events-none' : ''}`}
                                                onClick={!loading ? handlePlayPause : undefined}
                                            />

                                            {/* Clock Out Button */}
                                            <button onClick={handleClockOutClick} disabled={loading} className="bg-red-500 p-1 text-[1vw] text-white rounded-md">
                                                Clock Out
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : isClockOut ? (
                                <div className="flex justify-between items-center">
                                    <p className="text-gray-700 text-xs font-medium mt-2 border-l-2 border-cyan-600 text-left pl-2">
                                        You're clocked out.<br /> Ready to start soon again?
                                    </p>
                                    <div className="relative flex items-center justify-center w-[35%] cursor-pointer" onClick={handleClick}>
                                        <img className="w-full h-full" src={ellipse} alt="Round" />
                                        <div className="absolute flex flex-col items-center top-8">
                                            <img className="w-6 h-6" src={click} alt="Hand" />
                                            <p className="text-white text-xs font-semibold mt-1">Clocked out</p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex justify-between items-center rounded-lg">
                                    {/* Shift Time and Reminder */}
                                    <div>
                                        <p className="text-gray-700 text-xs font-medium">Shift Starts at</p>
                                        <p className="text-[1.15vw] font-semibold">
                                            {data?.shift_start_time ? ` ${formatTime12Hour(data.shift_start_time)}` : ""}
                                        </p>
                                        <p className="text-red-500 text-[10px] mt-1">Time to get things done—clock in and take charge!</p>
                                    </div>

                                    {/* Clock-In Button */}
                                    <div className="relative flex items-center justify-center w-[40%] cursor-pointer" onClick={handleClick}>
                                        <img className="w-full h-full" src={ellipse} alt="Round" />
                                        <div className="absolute flex flex-col items-center top-8 z-50">
                                            <img className="w-6 h-6" src={click} alt="Hand" />
                                            <p className="text-white text-xs font-semibold mt-1">Clock In</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Card>
                </div>
                <div className="div2">
                    <Card className="h-full bg-gradient-to-r from-white via-gray-100 to-white rounded-lg">
                        <div className="border-b flex justify-between items-center pb-1">
                            <p id="common_salary_subTxt" className="text-lg font-semibold text-gray-700">My Leaves</p>
                            <p id="common_salary_subTxt" className="text-sm font-medium text-gray-500">{`Leaves Status For ${currentYear}`}</p>
                        </div>

                        {/* Fancy Grid for Leaves */}
                        <div className="grid grid-cols-3 gap-4 mt-4">
                            {[
                                { label: "Total Leaves", value: my_leaves?.total_leaves ?? 0, color: "bg-blue-50 text-blue-500" },
                                { label: "Leaves Taken", value: my_leaves?.leaves_taken ?? 0, color: "bg-red-50 text-red-500" },
                                { label: "Available", value: my_leaves?.available_leaves ?? 0, color: "bg-green-50 text-green-500" },
                            ].map((item, index) => (
                                <div key={index} className={`p-2 rounded-lg shadow-md ${item.color} flex flex-col items-center justify-center transform hover:scale-105 transition-all`}>
                                    <p id="common_home_leaveTxt" className="text-2xl font-bold">{item.value}</p>
                                    <p id="common_salary_subTxt" className="text-sm font-medium">{item.label}</p>
                                </div>
                            ))}
                        </div>
                    </Card>
                </div>
                <div class="div3">
                    <Card className="h-full bg-gradient-to-r from-white via-gray-100 to-white rounded-lg">
                        {/* <p id="common_salary_subTxt" className='py-2 border-b'>Happy Meter</p> */}
                        <p id="common_salary_subTxt" className='py-2 border-b'>{`Hey ${employeeName}! Quick check—How about today? 😊`}</p>
                        <div className="w-dvw mt-5 flex justify-evenly items-center">
                            <div className="cursor-pointer" onClick={() => handleHappyMeterClk("happy")}>
                                <img className='happyMeter_icons hover:scale-105 transition-all' src={happyEmoji} alt="happy" />
                                <p className="happyMeter_txt">Happy</p>
                            </div>
                            <div className="cursor-pointer" onClick={() => handleHappyMeterClk("average")}>
                                <img className='happyMeter_icons hover:scale-105 transition-all' src={averageEmoji} alt="average" />
                                <p className="happyMeter_txt">Average</p>
                            </div>
                            <div className="cursor-pointer" onClick={() => handleHappyMeterClk("sad")}>
                                <img className='happyMeter_icons hover:scale-105 transition-all' src={sadEmoji} alt="sad" />
                                <p className="happyMeter_txt">Sad</p>
                            </div>
                        </div>
                    </Card>
                </div>
                <div class="div4">
                    <Card className="h-full bg-gradient-to-r from-white via-gray-100 to-white rounded-lg">
                        <p id="common_salary_subTxt" className='pb-2 border-b'>Upcoming Events</p>
                        <div className=' h-[70vh] overflow-y-auto'>
                            {
                                upcoming_events?.length > 0 ? upcoming_events?.map(item => {
                                    let dateArr = item?.date ? item?.date?.split("-") : [];
                                    let monthIndex = parseInt(dateArr[1]);
                                    let monthName = dateArr.length > 0 && monthIndex ? monthEnum[monthIndex].text : "";
                                    return (
                                    <div className="border rounded-md flex justify-between items-center m-3 p-3" key={item.employee_id}>
                                        <EmployeeDetails
                                            details={{
                                                title: item.title ? item.title : "",
                                                first_name: item.employee_name ? item.employee_name : "",
                                                last_name: "",
                                                designation_id: { ...item.designation },
                                                //id: item.employee_id
                                            }}
                                            icon={<Tooltip title={item.event === "birthday" ? "Birthday" : "Work Anniversary"} >
                                                <img src={item.event === "birthday" ? ImagePaths.birthDayIcon.default : ImagePaths.anniversaryIcon.default}
                                                    alt="event icon" className='event_icons' />
                                            </Tooltip>} />
                                        <div>
                                            <p id="common_employee_desTxt" style={{ fontWeight: 600 }}>{monthName}</p>
                                            <p id="common_home_upcomingTxt">{dateArr[2] ? dateArr[2] : ""}</p>
                                        </div>
                                    </div>
                                    )
                                }) : <div className=' flex justify-center items-center h-[100%]'>
                                <img className="noticeImg" src={ImagePaths.noDataFound.default} alt="No Data" />
                            </div>
                            }
                        </div>
                    </Card>
                </div>
                <div class="div5">
                    <Card className="h-full bg-gradient-to-r from-white via-gray-100 to-white rounded-lg">
                        <p id="common_salary_subTxt" className='pb-2 border-b'>Notice Board</p>
                        <div className="h-[70vh] overflow-y-auto p-4">
                            {notice_board?.length > 0 ? (
                                notice_board.map(item => {
                                const fileExtension = item?.attachment ? extractFileExtension(item?.attachment) : null;

                                // Set border and ribbon colors based on priority
                                const priorityStyles = {
                                    High: {
                                    border: 'border-red-500',
                                    ribbon: 'bg-red-600 text-white',
                                    label: '⚠️ High Priority',
                                    },
                                    Medium: {
                                    border: 'border-yellow-500',
                                    ribbon: 'bg-yellow-500 text-white',
                                    label: '⚠️ Medium Priority',
                                    },
                                    Low: {
                                    border: 'border-green-500',
                                    ribbon: 'bg-green-600 text-white',
                                    label: 'ℹ️ Low Priority',
                                    },
                                };

                                const currentPriority = priorityStyles[item.priority_level] || priorityStyles["Low"];

                                return (
                                    <div className="relative" key={item.id}>
                                    {/* Ribbon */}
                                    {
                                        // to mention the ribbon only for the notice contains selected employee with priority level
                                        item.notice_to_employee?.some(emp => emp.id === parseInt(sessionStorage.getItem("employee_id"))) && (
                                            <div className={`absolute -top-3 left-0 text-xs px-2 py-1 rounded-tr-md rounded-br-md font-medium ${currentPriority.ribbon}`}>
                                                {currentPriority.label}
                                            </div>
                                        )
                                    }

                                    {/* Card */}
                                    <div
                                        className={`text-[12px] bg-white shadow-md rounded-lg p-4 mb-6 transition hover:shadow-lg border-l-4 ${
                                            item.notice_to_employee?.some(emp => emp.id === parseInt(sessionStorage.getItem("employee_id")))
                                            ? currentPriority.border
                                            : 'border-gray-300'
                                        }`}
                                        >

                                        {/* Title */}
                                        <div className="flex justify-between items-center mb-2">
                                        <p className="text-xs font-semibold text-gray-800">{item?.notice_title || "Public Notice"}</p>
                                        </div>

                                        {/* Description */}
                                        <p className="text-gray-600 mb-4">
                                        {item?.description || "No Description Available"}
                                        </p>

                                        {/* Attachment Preview */}
                                        {fileExtension === 'pdf' ? (
                                        <img
                                            src={ImagePaths.documentPreview.default}
                                            alt="PDF preview"
                                            className="w-24 h-24 object-contain mb-4"
                                        />
                                        ) : fileExtension && item?.attachment ? (
                                        <img
                                            src={item.attachment}
                                            alt="Notice Attachment"
                                            className="w-full max-w-md rounded-md mb-4"
                                        />
                                        ) : null}

                                        {/* Footer */}
                                        <div className="flex justify-between text-xs items-center text-gray-500 mt-2 border-t pt-2">
                                        <span>
                                            Posted by: <strong className="text-gray-700">{item.notice_by || "-"}</strong>
                                        </span>
                                        <span>
                                            {item.published_date
                                            ? `${item.published_date.split("-").reverse().join("-")} | ${
                                                item?.published_time ? formatTimeToAMPM(item?.published_time) : "-"
                                                }`
                                            : ""}
                                        </span>
                                        </div>
                                    </div>
                                    </div>
                                );
                                })
                            ) : (
                                <div className="flex justify-center items-center h-full">
                                <img className="w-48" src={ImagePaths.noDataFound.default} alt="No Data" />
                                </div>
                            )}
                        </div>
                    </Card>
                </div>
            </div>
        </>
    );
}

const styles = {
    buttonStyle: {
        width: "6dvw",
        fontSize: "0.5dvw",
        backgroundColor: "#D94854",
        color: "white",
        border: "none",
        borderRadius: "2px",
        height: "2dvw",
    }
};

export default Home
